import * as C from "./Vars/charts";

import Helper from "./Classes/Helper.js";
import ChartDataHanlder from "./Classes/ChartDataHanlder.js";
import ChartDisplayHandler from "./Classes/ChartDisplayHandler.js";
import ChartTableHandler from "./Classes/ChartTableHandler.js";
import ChartXDownloader from "./Classes/ChartXDownloader";

(function () {
  document.addEventListener("DOMContentLoaded", () => {
    // globally set Language settings for Charts
    Highcharts.setOptions({
      lang: {
        decimalPoint: C.decimalPoint,
        numericSymbols: C.numericSymbols,
        thousandsSep: C.thousandsSep,
      },
    });

    // get URL parameters or set defaults if unset
    // aka, we'll always have parameters, empty arrays are voluntary
    C.updateURLParams(C.URLParams);
    // console.log(C.chartRenderCounter);

    // handle swapped legends button and update URL
    C.swappedLegendsBtn.forEach(btn => {
      let swappedLegends = C.URLParams["swappedLegends"];
      swappedLegends = (String(swappedLegends) == 'true');
      if(String(swappedLegends) == 'true'){
        Helper.addClass(btn, 'active')
        Helper.addClass(document.querySelector('body'), 'swapped-legends');
      }

      btn.addEventListener('click', e => {
        let swappedLegends = C.URLParams["swappedLegends"];
        let inactiveSeries = C.URLParams["inactiveSeries"];
        let inactiveCats = C.URLParams["inactiveCats"];

        C.URLParams["inactiveCats"] = inactiveSeries;
        C.URLParams["inactiveSeries"] = inactiveCats;

        swappedLegends = String(swappedLegends);
        if(swappedLegends == 'true'){
          swappedLegends = false;
          Helper.removeClass(btn, 'active');
          Helper.removeClass(document.querySelector('body'), 'swapped-legends');
        } else {
          swappedLegends = true;
          Helper.addClass(btn, 'active');
          Helper.addClass(document.querySelector('body'), 'swapped-legends');
        }

        C.URLParams["swappedLegends"] = swappedLegends;

        C.updateURLParams(C.URLParams);
        new ChartDataHanlder(document.querySelector(`${C.chartSwitchSelector}:checked`));
      });
    });


    // handle indexed values Button Click and update URL
    C.indexedValsBtn.forEach(btn => {
      let indexedVals = C.URLParams["indexedVals"];
      indexedVals = (String(indexedVals) == 'true') ? Helper.addClass(btn, 'active') : '';

      btn.addEventListener('click', e => {
        let indexedVals = C.URLParams["indexedVals"];
        indexedVals = String(indexedVals);
        if(indexedVals == 'true'){
          indexedVals = false;
          Helper.removeClass(btn, 'active');
        } else {
          indexedVals = true;
          Helper.addClass(btn, 'active');
        }
        C.URLParams["indexedVals"] = indexedVals;
        C.updateURLParams(C.URLParams);
        new ChartDisplayHandler();
      });
    });

    // process chart data for current chart and on click
    C.chartSwitches.forEach((chartSwitch) => {
      const currentChart = C.URLParams['chart'];
      if(currentChart == chartSwitch.id){
        chartSwitch.checked = true;
        C.legendsArray.forEach(legend => {
          if(legend.classList.contains('always-active')){
            legend.classList.add('active');
          } else {
            legend.classList.remove('active');
            legend.innerHTML = '';
          }
        });
        C.catsArray.forEach(cat => {
          if(cat.classList.contains('always-active')){
            cat.classList.add('active');
          } else {
          cat.classList.remove('active');
          cat.innerHTML = '';
          }
        });
        chartSwitch.nextElementSibling.nextElementSibling.classList.add('active'); // active legend div
        chartSwitch.nextElementSibling.nextElementSibling.nextElementSibling.classList.add('active'); // active category div
        new ChartDataHanlder(chartSwitch);
      }
      chartSwitch.addEventListener('click', (e) => {
        C.legendsArray.forEach(legend => {
          if(legend.classList.contains('always-active')){
            legend.classList.add('active');
          } else {
            legend.classList.remove('active');
            legend.innerHTML = '';
          }
        });
        C.catsArray.forEach(cat => {
          if(cat.classList.contains('always-active')){
            cat.classList.add('active');
          } else {
          cat.classList.remove('active');
          cat.innerHTML = '';
          }
        });
        chartSwitch.nextElementSibling.nextElementSibling.classList.add('active'); // active legend div
        chartSwitch.nextElementSibling.nextElementSibling.nextElementSibling.classList.add('active'); // active category div

        C.URLParams['chart'] = chartSwitch.id;
        C.URLParams["inactiveCats"] = ""; // reset inactives on chart switch
        C.URLParams["inactiveSeries"] = ""; // reset inactives on chart switch
        C.updateURLParams(C.URLParams);
        new ChartDataHanlder(chartSwitch);
      });
      chartSwitch.nextElementSibling.addEventListener('click', e => {
        Helper.slideClose(chartSwitch.parentElement.parentElement);
        Helper.removeClass(chartSwitch.parentElement.parentElement.previousElementSibling, 'active');
        document.querySelector('.ns-select-backdrop').remove();
      });
    });

    new ChartXDownloader();

    // change view Parameters based on click, set active based on URL Params
    C.viewSwitches.forEach((switcher) => {
      const paramName = switcher.value;
      const paramVal = C.URLParams[paramName];
      if(paramVal == 'true'){
        switcher.checked = true;

        if(paramName == 'isTable'){
          Helper.addClass(C.chartArea, 'show-table');
        } else {
          Helper.removeClass(C.chartArea, 'show-table');
        }
      }
      // handle rendering on click
      switcher.addEventListener('click', (e) => {
        C.viewSwitches.forEach((el) => {
          const paramName = el.value;
          const paramVal = el.checked;
          C.URLParams[paramName] = paramVal;
        });
        C.updateURLParams(C.URLParams);
        if(switcher.id == 'table'){
          Helper.addClass(C.chartArea, 'show-table');
        } else {
          Helper.removeClass(C.chartArea, 'show-table');
        }
        new ChartDisplayHandler();
      });
    });

    // Select Click Open
    C.chartSelects.forEach((el) => {
      el.addEventListener("click", (e) => {
        if (el.classList.contains("active")) {
          Helper.slideClose(el.nextElementSibling);
          el.classList.remove("active");
        } else {
          el.classList.add("active");
          Helper.slideOpen(el.nextElementSibling, true);

          const backdrop = document.createElement('div');
          backdrop.classList.add('ns-select-backdrop');
          backdrop.addEventListener('click', e => {
            Helper.slideClose(el.nextElementSibling);
            el.classList.remove('active');
            backdrop.remove();
          });
          document.querySelector('body').append(backdrop);
        }
      });
    });

    // Register Exports
      C.printBtn.forEach(btn => {
        btn.addEventListener('click', e => {
          window.print();
          // C.currentHighchart.print();
        });
      });
      C.exportPNGBtn.forEach(btn => {
        btn.addEventListener('click', e => {
          C.currentHighchart.exportChartLocal({
            type: 'image/png'
          });
          new ChartDisplayHandler();
        });
      });

  });
})();
